// extracted by mini-css-extract-plugin
export default {"select":"styles_select__C-cUb","error":"styles_error__bvIUT"};